<template>
  <div class="forget-pwd">
    <div class="login-box w1200">
      <img src="~@/assets/images/login_logo.png" alt="" class="login-img">
      <div class="login-form">
        <span class="fs20 fwn">元素魔方</span>
        <div class="under-line"></div>
        <div class="login-msg">
          <div class="phone-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_phone_icon.png" alt="">
            </div>
            <input type="text" name="" placeholder="请输入手机号" id="phone" v-model="form.phone">
          </div>
          <div class="code-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_msg_icon.png" alt="">
            </div>
            <input type="text" name="" placeholder="请输入短信验证码" id="code" v-model="form.code">
            <div class="send-code-btn flex-cc" @click="sendCode">
              {{ text }}
            </div>
          </div>
          <div class="new-pwd-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_pwd_icon1.png" alt="">
            </div>
            <input type="password" name="" placeholder="请输入新密码" id="newPwd" v-model="form.password">
          </div>
          <div class="new-pwd-inp">
            <div class="icon flex-cc">
              <img src="~@/assets/images/login_pwd_icon.png" alt="">
            </div>
            <input type="password" name="" placeholder="请确认新密码" id="newPwd" v-model="form.repassword">
          </div>
        </div>
        <el-button class="login-btn" @click="handleSubmit" :loading="loading">更新密码</el-button>
        <div class="register-entry fs14 fw300">
          <span></span>
          <span>已有账号，<router-link :to="{ path: '/auth/login' }">马上登录></router-link></span>
        </div>
      </div>
    </div>
    <!-- 滑动验证码 -->
    <Verify ref="verify" @success="captchaSuccess" mode="pop" :captchaType="form.captchaType"
      :imgSize="{ width: '330px', height: '155px' }"></Verify>
  </div>
</template>
<script>

import { getSystemConfig, sendCode } from "@/api/common";
import { forget } from "@/api/auth";

import { validatePhone } from "@/utils/validate";
import { getStorage } from "@/utils/auth";
//引入组件
import Verify from "@/components/verifition/Verify";
export default {
  name: "AuthForget",
  components: {
    Verify
  },
  data() {
    return {
      loading: false,
      disabled: false,
      countdown: 60,
      text: "发送验证码",
      config: {},
      form: {
        phone: getStorage("loginPhone") || '',
        password: '',
        repassword: '',
        code: '',
        captchaType: "blockPuzzle",
        captchaVerification: "",
      },
      timer: null,
    };
  },
  created() {
    //this.getSystemConfig()
  },
  methods: {
    getSystemConfig() {
      getSystemConfig({}).then((res) => {
        this.config = res.data
      }).catch((err) => {

      })
    },
    sendCode() {
      const that = this
      const _form = that.form;
      if (that.disabled) return
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      console.log(_form)
      if (!_form.captchaVerification) {
        this.$refs.verify.show()
        return;
      }
      that.disabled = true
      sendCode(that.form).then((res) => {
        that.timer = setInterval(() => {
          that.countdown--
          this.text = "重新发送(" + that.countdown + "s)"
          if (that.countdown == 0) {
            that.disabled = false
            that.text = '发送验证码'
            that.countdown = 60
            clearInterval(that.timer)
          }
        }, 1000)

        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '短信发送成功'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    captchaSuccess(params) {
      console.log(params);
      this.form = {
        ...this.form,
        ...params,
      }
      this.sendCode()
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    },
    //提交登录请求
    handleSubmit() {
      const that = this;
      const _form = this.form;
      if (!_form.phone) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!validatePhone(_form.phone)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码'
        });
        return;
      }
      if (!_form.password) {
        this.$message({
          type: 'error',
          message: '请输入密码'
        });
        return;
      }
      if (_form.password != _form.repassword) {
        this.$message({
          type: 'error',
          message: '密码和确认密码不一致'
        });
        return;
      }
      if (!_form.code) {
        this.$message({
          type: 'error',
          message: '请输入验证码'
        });
        return;
      }
      if (!_form.captchaVerification) {
        this.$refs.verify.show()
        return;
      }
      this.loading = true;
      forget(_form).then((res) => {
        this.loading = false;
        this.form.captchaVerification = '';
        this.$message({
          type: 'success',
          message: '密码重置成功，请登录！'
        }), this.$router.push('/auth/login')
      }).catch((err) => {
        this.form.captchaVerification = '';
        this.loading = false;
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/login.less';
</style>
